import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { Products } from 'src/app/core/constant/product.constants';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor
{
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const target = new URL(request.url, environment.baseUrl);
        const trusted = [environment.dentaFlowUrl, environment.oneApiUrl].some(value => {
            const api = new URL(value);
            const path = api.pathname.replace(/\/$/, '');
            return target.origin === api.origin &&
                (!path || target.pathname === path || target.pathname.startsWith(path + '/'));
        });
        if (!trusted) return next.handle(request);
        request = request.clone({
            setHeaders: {
                'X-App-id': Products.OneAPI.toString()
            },
        });
        const token = this.authenticationService.user?.access_token;
        if (!token || !this.authenticationService.isAuthenticated()) return next.handle(request);
        
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${ token }`
                },
            });
        
        return next.handle(request);
    }
}
